/* src/app/app.component.scss */
#splash-screen {
  width: 100%;
  height: 100%;
  z-index: 10000;
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  background: linear-gradient(#018FE1, #00507E);
}
/*# sourceMappingURL=app.component.css.map */
